module.exports = __webpack_public_path__ + "static/furniture-instagram-section-e90fb9c6622435cc560f5ea26720f91e.png";